export default __webpack_public_path__ + "static/media/circle-check-mark-green.cff9a243.svg";